/* ═══════════════════════════════════════════════════════
   IJOR — Theme JavaScript
═══════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Brand Stamp Intersection Observer ── */
  const brandStamp = document.getElementById('brandStamp');
  if (brandStamp) {
    const bsObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('bs-visible');
          bsObs.disconnect();
        }
      });
    }, { threshold: 0.15 });
    bsObs.observe(brandStamp);
  }

  /* ── Category entries scroll reveal ── */
  const catEntries = document.querySelectorAll('.cat-entry');
  if (catEntries.length) {
    const catObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.08 });
    catEntries.forEach(el => catObs.observe(el));
  }

  /* ── Craft Tab switcher ── */
  window.switchTab = function (el) {
    const wrap = el.closest('.vtabs-wrap');
    if (!wrap) return;
    wrap.querySelectorAll('.vtab').forEach(t => t.classList.remove('active'));
    wrap.querySelectorAll('.vpanel').forEach(p => p.classList.remove('active'));
    el.classList.add('active');
    const target = el.dataset.panel;
    const panel = wrap.querySelector('#' + target);
    if (panel) panel.classList.add('active');
  };

  /* ── Stats counter animation ── */
  const stats = document.querySelectorAll('.stat-num[data-target]');
  if (stats.length) {
    const statObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const el = e.target;
        const raw = el.dataset.target;
        const suffix = raw.replace(/[\d,]/g, '');
        const target = parseInt(raw.replace(/[^0-9]/g, ''));
        let current = 0;
        const inc = Math.ceil(target / 80);
        const timer = setInterval(() => {
          current = Math.min(current + inc, target);
          el.textContent = current.toLocaleString('en-IN') + suffix;
          if (current >= target) clearInterval(timer);
        }, 18);
        statObs.unobserve(el);
      });
    }, { threshold: 0.3 });
    stats.forEach(s => statObs.observe(s));
  }

  /* ── Cart drawer / count update ── */
  // document.addEventListener('click', function (e) {
  //   // Add to cart intercept for dynamic cart count
  //   const form = e.target.closest('form[action*="cart/add"]');
  //   if (!form) return;
  //   e.preventDefault();
  //   const formData = new FormData(form);
  //   fetch('/cart/add.js', {
  //     method: 'POST',
  //     body: formData
  //   })
  //   .then(r => r.json())
  //   .then(() => {
  //     return fetch('/cart.js');
  //   })
  //   .then(r => r.json())
  //   .then(cart => {
  //     const countEl = document.querySelector('.cart-count');
  //     if (countEl) countEl.textContent = cart.item_count;
  //     showCartNotification();
  //   })
  //   .catch(err => {
  //     // Fallback to normal form submit
  //     form.submit();
  //   });
  // });

  // function showCartNotification() {
  //   let notif = document.getElementById('cart-notif');
  //   if (!notif) {
  //     notif = document.createElement('div');
  //     notif.id = 'cart-notif';
  //     notif.style.cssText = `
  //       position:fixed;bottom:32px;right:32px;z-index:9999;
  //       background:var(--brown);color:var(--goldl);
  //       font-family:var(--ff-sans);font-size:.72rem;font-weight:700;
  //       letter-spacing:.15em;text-transform:uppercase;
  //       padding:14px 24px;border-radius:2px;
  //       border-left:4px solid var(--gold);
  //       box-shadow:0 8px 32px rgba(61,40,16,.35);
  //       transform:translateY(20px);opacity:0;
  //       transition:transform .3s ease,opacity .3s ease;
  //     `;
  //     document.body.appendChild(notif);
  //   }
  //   notif.textContent = '✦ Added to Cart';
  //   requestAnimationFrame(() => {
  //     notif.style.transform = 'translateY(0)';
  //     notif.style.opacity = '1';
  //   });
  //   setTimeout(() => {
  //     notif.style.transform = 'translateY(20px)';
  //     notif.style.opacity = '0';
  //   }, 2800);
  // }

  /* ── Sticky nav shadow on scroll ── */
  const nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(61,40,16,.18)'
        : 'none';
    }, { passive: true });
  }

  /* ── Mobile nav toggle ── */
  const mobileToggle = document.querySelector('.nav-mobile-toggle');
  const navLinks = document.querySelector('.nav-links');
  if (mobileToggle && navLinks) {
    mobileToggle.addEventListener('click', () => {
      navLinks.classList.toggle('mobile-open');
    });
  }

  /* ── Wishlist heart toggle ── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.prod-wishlist, .btn-wishlist-full');
    if (!btn) return;
    btn.classList.toggle('wished');
    btn.textContent = btn.classList.contains('wished') ? '♥' : '♡';
    btn.style.color = btn.classList.contains('wished') ? 'var(--terra)' : '';
  });

  /* ── Image gallery (product page) ── */
  window.switchImage = function (thumb, src) {
    const mainImg = document.getElementById('mainImg');
    if (mainImg) {
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity .2s';
      setTimeout(() => {
        mainImg.src = src;
        mainImg.style.opacity = '1';
      }, 200);
    }
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  };

  /* ── Qty controls ── */
  window.changeQty = function (dir) {
    const el = document.getElementById('qty');
    if (el) el.value = Math.max(1, Math.min(99, parseInt(el.value || 1) + dir));
  };

})();
// Hamburger menu
(function () {
  var hamburger = document.getElementById('nav-hamburger');
  var drawer = document.getElementById('nav-drawer');
  var overlay = document.getElementById('nav-overlay');

  function openMenu() {
    hamburger.classList.add('open');
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    hamburger.classList.remove('open');
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  overlay.addEventListener('click', closeMenu);
  document.getElementById('nav-drawer-close').addEventListener('click', closeMenu);

  // Submenu toggle
  document.querySelectorAll('.nav-drawer-link').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var item = link.closest('.nav-drawer-item');
      if (item.querySelector('.nav-drawer-sub')) {
        e.preventDefault();
        item.classList.toggle('open');
      }
    });
  });
})();